import React from 'react';
import {AssetResponseItem, GenericAsset, TweetAsset} from "@/@types/AssetTypes.ts";
import FacebookPostPreview from "../../components/previews/FacebookPostPreview.tsx";
import TwitterThreadPreview from "@/components/previews/TwitterThreadPreview.tsx";
import InstagramPostPreview from "@/components/previews/InstagramPostPreview.tsx";

function PostPreview({post, account, metrics, post_at, type}:{
    type:string;
    account?: AssetResponseItem['account'],
    post_at?: string,
    metrics?: AssetResponseItem['metrics']
    post: GenericAsset['post'] | TweetAsset['post']
}) {

    if(type === "facebook-page-post"){
        return <FacebookPostPreview
            account={account}
            post_at={post_at}
            post={post as GenericAsset['post']} />
    }
    if(type === "twitter-post"){
        // return <pre>{JSON.stringify(post, null, 2)}</pre>
        return <TwitterThreadPreview
            account={account}
            post_at={post_at}
            post={{post} as TweetAsset} />
    }else if(type === "instagram-post"){
        return <InstagramPostPreview
            metrics={metrics}
            account={account}
                                        post_at={post_at}
                                        post={post as GenericAsset['post']} />
    }

    return (
        <div className={"text-center"}>Preview not available</div>
    );
}

export default PostPreview;
